import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faGithubSquare } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faRocket } from "@fortawesome/free-solid-svg-icons";
import { selectTitleState, setTitles, setSubtitles } from '../../store/features/titleSlice';
import { useSelector, useDispatch } from "react-redux";
import Typed from 'typed.js';
import { db } from "../../services/firebase/firebase";
import { collection, getDocs } from 'firebase/firestore';
import "./Home.css"; 

const Home = (props) => {
    const subtitleDelayMs = 100;

    const titles = [
        "Full Stack Developer",
        "IT Manager",
        "Project Manager",
    ];
    const subtitles = [
        "I design and create webapps using React/Next.js and NodeJS",
        "I manage projects and IT teams",
        // "I set technological directions of companies"
        "I work with web3 technologies"
    ];

    const baseTitleOptions = {
        typeSpeed: 80,
        backDelay: 1500,
        backSpeed: 80,
    };

    const baseSubtitleOptions = {
        typeSpeed: 80,
        backDelay: 2000,
        backSpeed: 80,
    };

    const getOptions = () => {
        let titleOptions = baseTitleOptions;
        titleOptions["strings"] = titles;
        titleOptions["loop"] = titles.length > 1;
        titleOptions["loopCount"] = titles.length > 1 ? Infinity : 0;
    
        let subtitleOptions = baseSubtitleOptions;
        subtitleOptions["strings"] = subtitles;
        subtitleOptions["startDelay"] = subtitleDelayMs * titles.length;
        subtitleOptions["loop"] = subtitles.length > 1;
        subtitleOptions["loopCount"] = subtitles.length > 1 ? Infinity : 0;

        return { titleOptions, subtitleOptions };
    }

    useEffect(() => {
        let titleOptions = getOptions().titleOptions;
        titleOptions["strings"] = [...titles];
    
        let subtitleOptions = getOptions().subtitleOptions;
        subtitleOptions["strings"] = [...subtitles];
        subtitleOptions["startDelay"] = subtitleDelayMs;

        const titleTyped = new Typed("#impressum-title", titleOptions);
        const subtitleTyped = new Typed("#impressum-subtitle", subtitleOptions);
    }, []);

    return (
        <div className="home">
            <div className="impressum">
                <div className="typed-container typed-title"><span id="impressum-title"></span></div>
                <div className="typed-container typed-subtitle"><span id="impressum-subtitle"></span></div>
            </div>
            <div className="socials">
                <a href={process.env.REACT_APP_LINKEDIN_LINK} target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faLinkedin} /></a>
                <a href={process.env.REACT_APP_GITHUB_LINK} target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faGithubSquare} /></a>
                <a href={"mailto:" + process.env.REACT_APP_CONTACT_EMAIL} target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faEnvelope} /></a>
            </div>
        </div>
    );
}

export default Home;